<template>
  <span class="small-block">
      <div class="bj">
        <img src="/static/images/svolt/small-block-bj.png"/>
      </div>
      <div class="content">
            <div class="s-title">{{data.title}}<span v-if="data.unit">({{data.unit}})</span></div>
            <div class="s-number" :class="{'s-blue':color=='blue','s-yellow':color=='yellow','s-green':color=='green'}">{{data.number}}</div>
      </div>
  </span>
</template>

<script>
  export default{
    props:{
      data:{
        type:Object
      },
      color:{
        type:String
      },
      width:{
        type:[Number,String],
        default:124
      },
      height:{
        type:[Number,String],
        default:42
      }
    },
    data(){
      return {
        title:''
      }
    },
    methods:{
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  .small-block{
   position: relative;
   top: 0;
   left: 0;
   width: 100%;
   height: 53px;
   overflow: hidden;
   display: inline-block;
   margin:0px 1px;
   .bj{
     position: absolute;
     top: 0px;
     left: 0px;
     z-index: 1;
     width: 100%;
     img{
       width: 100%;
       height: 48px;
     }
   }
   .content{
     position: absolute;
     top: 0px;
     left: 0px;
     z-index: 10;
     width: 100%;
     min-width: max-content;
     height: 53px;
     text-align: center;
     .s-title{
       font-size: 12px;
       font-family: MicrosoftYaHei;
       color: #FFFFFF;
       width: 100%;
       text-align: center;
       margin-top:8px;
     }
     .s-number{
       font-size: 16px;
       font-family: DINBold,DINAlternate;
       color: #76DEFC;
       margin-top:2px;
     }
     .s-blue{
       color:#76DEFC !important;
     }
     .s-yellow{
       color:#FFD478 !important;
     }
     .s-green{
       color:#77FFA7 !important;
     }
   }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/small-block.vue